import React from "react";
import { useSeason } from "@/lib/season";
import SpeakButton from "@/components/SpeakButton";
import { useAuth } from "@/lib/auth";

/**
 * A single daily seasonal micro-prompt overlay on the Dashboard.
 * Renders in italic serif, framed by the season's accent colour.
 */
export default function SeasonMicroPrompt() {
  const season = useSeason();
  const { user } = useAuth();
  if (!season || !season.micro_prompt) return null;

  return (
    <div
      className="mb-14 border-l-2 pl-6 py-2 max-w-2xl animate-fade-up flex items-start justify-between gap-4"
      style={{ borderColor: season.accent }}
      data-testid="season-microprompt"
    >
      <div className="flex-1">
        <p
          className="font-sans uppercase tracking-[0.24em] text-[0.65rem] mb-3"
          style={{ color: season.accent }}
        >
          Today · {season.label}
        </p>
        <p className="font-serif italic text-xl md:text-2xl text-bone-100 leading-snug">
          {season.micro_prompt}
        </p>
      </div>
      {user && (
        <SpeakButton
          text={season.micro_prompt}
          size="sm"
          testId="speak-season-microprompt"
          label="Read today's prompt aloud"
        />
      )}
    </div>
  );
}
